var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-company-info-wrapper",
    { attrs: { company: _vm.company, "no-scroll": "" } },
    [
      _c(
        "w-row",
        { attrs: { center: "", shrink: "" } },
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-scroll-view",
                { style: { height: "100%" }, attrs: { tag: "w-card" } },
                [
                  _c(
                    "w-list",
                    [
                      _c(
                        "w-list-item",
                        [
                          _c("w-list-item-text", [_vm._v("id")]),
                          _c("w-list-item-text", [_vm._v("date")]),
                          _c("w-list-item-text", [_vm._v("status")]),
                          _c("w-list-item-text"),
                          _c(
                            "w-list-item-text",
                            { staticClass: "right-align" },
                            [_vm._v(" amount ")]
                          ),
                        ],
                        1
                      ),
                      _vm._l(_vm.invoices, function (invoice) {
                        return _c(
                          "w-list-item",
                          { key: invoice.id },
                          [
                            _c("w-list-item-text", [
                              _vm._v(_vm._s(invoice.id)),
                            ]),
                            _c("w-list-item-text", [
                              _vm._v(
                                _vm._s(_vm._f("dateString")(invoice.date))
                              ),
                            ]),
                            _c("w-list-item-text", [
                              _vm._v(_vm._s(invoice.status)),
                            ]),
                            _c(
                              "w-list-item-text",
                              [
                                _c(
                                  "w-link",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.showPlan(invoice)
                                      },
                                    },
                                  },
                                  [_vm._v(" show plan ")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "w-list-item-text",
                              { staticClass: "right-align" },
                              [
                                _vm._v(
                                  " €" +
                                    _vm._s(
                                      _vm._f("humanFloat")(invoice.amount)
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          attrs: { value: _vm.selectedInvoice != null, "escape-close": "" },
          on: {
            input: function ($event) {
              _vm.selectedInvoice = null
            },
          },
        },
        [
          _vm.selectedInvoice
            ? _c("app-company-plan", {
                attrs: { "plan-metadata": _vm.selectedInvoice },
                on: {
                  close: function ($event) {
                    _vm.selectedInvoice = null
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }